






































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

import SelectStadium from "@/components/selectstadium.vue";

@Component({
  components: {
    SelectStadium
  }
})
export default class extends Mixins(MyList) {
  dispatchType = "footprint/list";

  editTypes: any[] = [
    { name: "馆长昵称", value: "1" },
    { name: "公告", value: "3" },
    { name: "场馆照片", value: "4" },
    { name: "场馆基本信息", value: "5" },
    { name: "场馆营业信息", value: "6" },
    { name: "场馆场地信息", value: "7" },
    { name: "场馆场地价格时段", value: "8" },
    { name: "场馆经营资质", value: "9" },
    { name: "场馆附件", value: "10" },
    { name: "场馆经营资质-营业执照", value: "91" },
    { name: "场馆经营资质-身份证人身面", value: "92" },
    { name: "场馆经营资质-身份证国徽面", value: "93" },
    { name: "场馆经营资质-手持身份证", value: "94" }
  ];

  columns: any[] = [
    {
      title: "编号",
      dataIndex: "id"
    },
    {
      title: "场馆",
      dataIndex: "data",
      customRender: (text: any, record: any, index: any) => {
        const obj: any = JSON.parse(text);
        return obj.Stadium.name;
      }
    },
    {
      title: "变更项目",
      scopedSlots: { customRender: "tag" }
    },
    {
      title: "变更时间",
      dataIndex: "created_time"
    },
    { title: "变更前" },
    { title: "变更后" },
    { title: "状态" }
  ];

  mounted() {
    this.loadData();
  }
}
